// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 start
import { createAsyncThunk } from '@reduxjs/toolkit';
import { educationService } from 'services';
import {
  ThunkAPI,
  GetEducationStatusRequest,
  GetEducationStatusResponse,
  GetNewentrantEducationRequest,
  GetNewentrantEducationResponse,
  GetUpperCooperatorListRequest,
  GetUpperCooperatorListResponse,
  GetSendoffEducationRequest,
  GetSendoffEducationResponse,
  EducationNewentrantRegisterRequest,
  EducationSendoffRegisterRequest,
  // 2024/01/08 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
  EducationSendphotoRequest,
  // 2024/01/08 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
} from 'types';

interface ActionError {}

export const getEducationStatus = createAsyncThunk<
  GetEducationStatusResponse,
  GetEducationStatusRequest,
  ThunkAPI<ActionError>
>('newentrantSendoff/thunk/getEducationStatus', async (params, { rejectWithValue }) => {
  try {
    const { data } = await educationService.getEducationStatus(params);

    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const getNewentrantEducation = createAsyncThunk<
  GetNewentrantEducationResponse,
  GetNewentrantEducationRequest,
  ThunkAPI<ActionError>
>('newentrantSendoff/thunk/getNewentrantEducation', async (params, { rejectWithValue }) => {
  try {
    const { data } = await educationService.getNewentrantEducation(params);

    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const getUpperCooperatorList = createAsyncThunk<
  GetUpperCooperatorListResponse,
  GetUpperCooperatorListRequest,
  ThunkAPI<ActionError>
>('newentrantSendoff/thunk/getUpperCooperatorList', async (params, { rejectWithValue }) => {
  try {
    const { data } = await educationService.getUpperCooperatorList(params);

    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const getSendoffEducation = createAsyncThunk<
  GetSendoffEducationResponse,
  GetSendoffEducationRequest,
  ThunkAPI<ActionError>
>('newentrantSendoff/thunk/getSendoffEducation', async (params, { rejectWithValue }) => {
  try {
    const { data } = await educationService.getSendoffEducation(params);

    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const educationNewentrantRegister = createAsyncThunk<
  undefined,
  EducationNewentrantRegisterRequest,
  ThunkAPI<ActionError>
>('newentrantSendoff/thunk/educationNewentrantRegister', async (params, { rejectWithValue }) => {
  try {
    const { data } = await educationService.educationNewentrantRegister(params);
    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const educationSendoffRegister = createAsyncThunk<
  undefined,
  EducationSendoffRegisterRequest,
  ThunkAPI<ActionError>
>('newentrantSendoff/thunk/educationSendoffRegister', async (params, { rejectWithValue }) => {
  try {
    const { data } = await educationService.educationSendoffRegister(params);
    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});
// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 end
// 2024/01/08 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
export const educationSendphoto = createAsyncThunk<
  undefined,
  EducationSendphotoRequest,
  ThunkAPI<ActionError>
>('newentrantSendoff/thunk/educationSendphoto', async (params, { rejectWithValue }) => {
  try {
    const { data } = await educationService.educationSendphoto(params);
    return data;
  } catch (err) {
    return rejectWithValue(err);
  }
});
// 2024/01/08 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
